<template>
  <el-dialog title="人员设置" :visible.sync="dialogClockConfigVisible" width="25%" :close-on-click-modal="false">
    <el-form :model="clockConfigForm" :rules="rules" ref="clockConfigForm">
      <el-form-item label="运维员预警值" label-width="110px" prop="dispatcherAlertThreshold">
        <el-input v-model="clockConfigForm.dispatcherAlertThreshold" style="width: 200px">
          <template #append>%</template>
        </el-input>
      </el-form-item>
      <el-form-item label="监管员配备值" label-width="110px" prop="superviserAssignedNum">
        <el-input v-model="clockConfigForm.superviserAssignedNum" style="width: 200px">
          <template #append>人</template>
        </el-input>
      </el-form-item>
      <el-form-item label="监管员预警值" label-width="110px" prop="superviserAlertThreshold">
        <el-input v-model="clockConfigForm.superviserAlertThreshold" style="width: 200px">
          <template #append>%</template>
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialogClockConfig">取 消</el-button>
      <el-button type="primary" @click="saveDialogClockConfigForm">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import Api from '@/api'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      dialogClockConfigVisible: false, // 考勤打卡人员设置弹框
      clockConfigForm: {
        dispatcherAlertThreshold: '',
        superviserAssignedNum: '',
        superviserAlertThreshold: ''
      },
      clockConfigInfo: {}, // 考勤打卡人员设置信息
      rules: {
        dispatcherAlertThreshold: [
          { required: true, message: '运维员预警值不能为空', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '运维员预警值必须是大于0的整数', trigger: 'blur' }
        ],
        superviserAssignedNum: [
          { required: true, message: '监管员配备值不能为空', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '监管员配备值必须是大于0的整数', trigger: 'blur' }
        ],
        superviserAlertThreshold: [
          { required: true, message: '监管员预警值不能为空', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '监管员预警值必须是大于0的整数', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters([
      'selfAreaId',
      'user'
    ])
  },
  methods: {
    // 考勤打卡人员设置
    addClockEmployeeConfig() {
      Api.getClockConfigList(this.selfAreaId).then(res => {
        if (res.code === 200 && res.data) {
          this.clockConfigInfo = res.data
          console.log(this.clockConfigInfo)
          this.clockConfigForm.dispatcherAlertThreshold = res.data.dispatcherAlertThreshold
          this.clockConfigForm.superviserAssignedNum = res.data.superviserAssignedNum
          this.clockConfigForm.superviserAlertThreshold = res.data.superviserAlertThreshold
        }
        this.dialogClockConfigVisible = true
      })
    },
    // 保存考勤打卡人员设置
    saveDialogClockConfigForm() {
      this.$refs.clockConfigForm.validate((valid) => {
        if (valid) {
          let params = {}
          const dispatcherAlertThreshold = this.clockConfigForm.dispatcherAlertThreshold
          const superviserAssignedNum = this.clockConfigForm.superviserAssignedNum
          const superviserAlertThreshold = this.clockConfigForm.superviserAlertThreshold
          if (Object.keys(this.clockConfigInfo).length === 0) {
            // 新增
            params = {
              areaId: this.selfAreaId,
              dispatcherAlertThreshold: dispatcherAlertThreshold,
              superviserAssignedNum: superviserAssignedNum,
              superviserAlertThreshold: superviserAlertThreshold,
              createBy: this.user.id
            }
          } else {
            // 修改
            this.$set(this.clockConfigInfo, 'dispatcherAlertThreshold', dispatcherAlertThreshold)
            this.$set(this.clockConfigInfo, 'superviserAssignedNum', superviserAssignedNum)
            this.$set(this.clockConfigInfo, 'superviserAlertThreshold', superviserAlertThreshold)
            this.$set(this.clockConfigInfo, 'updateBy', this.user.id)
            params = this.clockConfigInfo
          }
          Api.saveClockConfigInfo(this.selfAreaId, params).then(res => {
            if (res.code === 200) {
              this.closeDialogClockConfig()
              this.$message.success('人员设置成功')
            } else {
              this.$message.warning(res && res.message)
            }
          }).catch((e) => {
            console.log('操作考勤站点信息异常：', e)
          })
        } else {
          return false
        }
      })
    },
    // 关闭考勤打卡人员设置
    closeDialogClockConfig() {
      this.dialogClockConfigVisible = false
      this.$refs.clockConfigForm.resetFields()
    }
  }
}
</script>
<style scoped lang="less">

</style>
